import { Outlet } from "react-router-dom";
import { useState } from "react";

import ChartExplorer from "@/appComponents/Blocks/Modals/ChartExplorerModal/ChartExplorerModal";
import FileManagerModal from "@/appComponents/Blocks/Modals/FileManagerModal/FileManagerModal";
import MainNavigation from "@/appComponents/Navigation/MainNavigation/MainNavigation";
import { DialogManager } from "@/appComponents/Blocks/Modals/Dialog/Dialog";
import { ChartCanvas } from "@/appComponents/Blocks/Composites/ChartCanvas/ChartCanvas";
import { MfaModalWrapper } from "../../Modals/SettingsModal/AccountSettings/ManageUsers/MfaModal";
import { useFileManagerContext } from "@/providers/FileManagerProvider";
import { useNavigationContext } from "@/providers/NavigationProvider";
import { useDirtyBlocker } from "@/hooks/useDirtyBlocker";
import { useLegacyUrlRedirect } from "@/hooks/useLegacyUrlRedirect";
import { useUrlSecurityGate } from "@/hooks/useUrlSecurityGate";
import { useAppReady } from "@/hooks/useAppReady";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { ChartBuilder } from "../../Modals/ChartBuilderModal/ChartBuilder";
import { ErrorBoundary } from "../../Utils/ErrorBoundary/ErrorBoundary";
import { CreateBaseChartModalWrapper } from "../../Modals/CreateBaseChartModal/CreateBaseChartModal";
import { GatedModals } from "../ModalHost/GatedModals";
import { Globals } from "@coreapp/CoreApp/Globals";
import { gShowMainNavigation } from "@coreapp/whitelabel/brand";
import { enumBrand } from "@coreapp/constants";
import BrandSetupModal from "../../Modals/BrandSetupModal/BrandSetupModal";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import GuideOrchestrator from "@/appComponents/Blocks/NativeGuides/orchestration/GuideOrchestrator";
import NativeResourceCenter from "@/appComponents/Blocks/NativeGuides/orchestration/NativeResourceCenter";
import NativeGuidesProvider from "@/appComponents/Blocks/NativeGuides/orchestration/NativeGuidesProvider";
import { RightSidebarSlotContext } from "./RightSidebarSlot";

function AppLayout() {
  const { contextValue } = useFileManagerContext();
  const {
    chartExplorer: { showChartExplorer },
    isPhoneLayout
  } = useNavigationContext();
  useChartDocumentContext();
  useDirtyBlocker();
  useLegacyUrlRedirect();
  useUrlSecurityGate();

  const appReady = useAppReady();
  const { shouldShowNavigation } = usePermissionCheck();
  const isEmbeddedMode = Globals._uiConfig?.fEmbeddedMode ?? false;

  const navFlagEnabled = Globals._uiConfig?.fHasNavigation !== false;
  const showMainNav =
    !isEmbeddedMode &&
    !isPhoneLayout &&
    gShowMainNavigation &&
    (appReady ? shouldShowNavigation : navFlagEnabled);
  const [rightSidebarSlot, setRightSidebarSlot] = useState(null);

  const containerClassName = [
    "appContainer",
    isEmbeddedMode ? "embedded-mode" : showMainNav ? null : "no-nav",
    isPhoneLayout ? "is-phone" : null
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="appBody">
      <div className="appDashboard">
        <div className={containerClassName}>
          <RightSidebarSlotContext.Provider value={rightSidebarSlot}>
            {appReady && <Outlet />}
          </RightSidebarSlotContext.Provider>
          <ErrorBoundary>
            <ChartCanvas />
          </ErrorBoundary>
          <div ref={setRightSidebarSlot} className="appRightSidebarSlot" />
          {showMainNav && (
            <div className="mainNav">
              <ErrorBoundary>
                <MainNavigation />
              </ErrorBoundary>
            </div>
          )}
          <div id="modal-root" />
          <GatedModals>
            <ChartBuilder />
            {contextValue.showFileManager && (
              <FileManagerModal show={contextValue.showFileManager} />
            )}
            <CreateBaseChartModalWrapper />
            {showChartExplorer && <ChartExplorer />}
            <BrandSetupModal />
          </GatedModals>
          <MfaModalWrapper />
          <DialogManager />
          <NativeGuidesProvider>
            <GuideOrchestrator />
            <NativeResourceCenter />
          </NativeGuidesProvider>
          <div id="notification-root" />
        </div>
      </div>
    </div>
  );
}

export default AppLayout;
